import { render, staticRenderFns } from "./hotel-mask.vue?vue&type=template&id=4a826b26&scoped=true&"
import script from "./hotel-mask.vue?vue&type=script&lang=js&"
export * from "./hotel-mask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a826b26",
  null
  
)

export default component.exports